<div>
  @if (editMode) {
    <div class="flex-horizontal-space-between">
      <a class="h6">Verweise</a>
      <div style="display:grid">
        <button (click)="edit()" style="justify-self: end; margin: 8px" color="primary" mat-raised-button>Bearbeiten</button>
      </div>
    </div>
  }
  <table [dataSource]="entries" class="w100 table marg-bot8 pad4" mat-table>
    <!-- attribute column -->
    <ng-container matColumnDef="attribute">
      <th *matHeaderCellDef mat-header-cell> attribute</th>
      <td *matCellDef="let element" mat-cell>{{ element[0] }}</td>
    </ng-container>

    <!-- value column -->
    <ng-container matColumnDef="value">
      <th *matHeaderCellDef mat-header-cell> value</th>
      <td *matCellDef="let element" mat-cell class="value-cell">
        @for (e of element[1]; track e; let i = $index) {
          <ng-template #niveauAndName>
            @if (e.productive) {
              <span class="niveau-dot"
                    [class.niveau-dot-all]="e.productive==='NONE'"
                    [class.niveau-dot-a0]="e.productive==='A0'"
                    [class.niveau-dot-a1]="e.productive==='A1'"
                    [class.niveau-dot-a2]="e.productive==='A2'"
                    [class.niveau-dot-b1]="e.productive==='B1'"
                    [class.niveau-dot-b2]="e.productive==='B2'"
                    [class.niveau-dot-c1]="e.productive==='C1'"
                    [class.niveau-dot-c2]="e.productive==='C2'"></span>
            }
            {{ e.name }}
            @if (countryFlagSrc(e); as flagSrc) {
              <img [src]="flagSrc" class="country-flag" alt="{{ e.country }}">
            }
          </ng-template>
          @if (clickableRefs) {
            <mat-chip-row (click)="openDetails(e)" class="hover">
              <ng-container [ngTemplateOutlet]="niveauAndName"></ng-container>
            </mat-chip-row> <a>&nbsp;</a>
          } @else {
            <span>
              <ng-container [ngTemplateOutlet]="niveauAndName"></ng-container>
            </span>@if (i < element[1].length - 1) {
              <a>, </a>
            }
          }
        }
      </td>
    </ng-container>

    <!-- Row shown when there is no matching data. -->
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="2"><h4 class="no-data-row-text">Keine Verweise vorhanden</h4></td>
    </tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

</div>
